/**
 * @format
 */
import { api } from '@/scripts/api';

export const MDFTimelineService = {
    clientGet(clientAccountId, requestId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/client-account/${clientAccountId}/requests/${requestId}/timeline?order=[["Id", "desc"]]`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    agencyGet(clientAccountId, requestId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/vendor-account/${clientAccountId}/requests/${requestId}/timeline?order=[["Id", "desc"]]`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    agencyGetAllHistory(clientAccountId, vendorAccountId, isPreapprovedFund) {
        return new Promise((resolve, reject) => {
            let service = `/ms/marketing-development-funds/v1/timelines/vendor-account/${vendorAccountId}/client-timelines/${clientAccountId}/grouped?order=[["Id", "desc"]]`;
            if (isPreapprovedFund) {
                service = service + '&preapproveFunds=true';
            }
            api.get(service).then(resolve).catch(reject);
        });
    },

    clientGetAllHistory(clientAccountId, vendorAccountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/timelines/client-account/${vendorAccountId}/client-timelines/${clientAccountId}/grouped?order=[["Id", "desc"]]`;
            api.get(service).then(resolve).catch(reject);
        });
    },
};
